export interface WhatsAppTemplateDefinition {
  key: string;
  labelKey: string;
  descriptionKey: string;
  placeholders: string[];
}

export const WHATSAPP_TEMPLATE_CATALOG: WhatsAppTemplateDefinition[] = [
  {
    key: 'task_assignment',
    labelKey: 'features.automations.whatsapp.templates.task_assignment.label',
    descriptionKey: 'features.automations.whatsapp.templates.task_assignment.description',
    placeholders: ['assigneeName', 'cardTitle', 'dueDate'],
  },
  {
    key: 'task_reminder',
    labelKey: 'features.automations.whatsapp.templates.task_reminder.label',
    descriptionKey: 'features.automations.whatsapp.templates.task_reminder.description',
    placeholders: ['cardTitle', 'dueDate'],
  },
  {
    key: 'task_request_update',
    labelKey: 'features.automations.whatsapp.templates.task_request_update.label',
    descriptionKey: 'features.automations.whatsapp.templates.task_request_update.description',
    placeholders: ['cardTitle', 'requesterName'],
  },
  {
    key: 'task_update',
    labelKey: 'features.automations.whatsapp.templates.task_update.label',
    descriptionKey: 'features.automations.whatsapp.templates.task_update.description',
    placeholders: ['cardTitle', 'status'],
  },
  {
    key: 'task_closed',
    labelKey: 'features.automations.whatsapp.templates.task_closed.label',
    descriptionKey: 'features.automations.whatsapp.templates.task_closed.description',
    placeholders: ['cardTitle', 'closedByName'],
  },
  {
    key: 'daily_agenda',
    labelKey: 'features.automations.whatsapp.templates.daily_agenda.label',
    descriptionKey: 'features.automations.whatsapp.templates.daily_agenda.description',
    placeholders: ['date', 'agendaItems'],
  },
  {
    key: 'daily_summary',
    labelKey: 'features.automations.whatsapp.templates.daily_summary.label',
    descriptionKey: 'features.automations.whatsapp.templates.daily_summary.description',
    placeholders: ['date', 'summaryItems'],
  },
  {
    key: 'otp_authentication',
    labelKey: 'features.automations.whatsapp.templates.otp_authentication.label',
    descriptionKey: 'features.automations.whatsapp.templates.otp_authentication.description',
    placeholders: ['otpCode', 'expirationMinutes'],
  },
];
